import { API } from 'config';

function ContactService($http) {

  'ngInject';

  return {
    send: (message) => $http.post(API.CONTACT, message),
  };
}

export default ContactService;



// WEBPACK FOOTER //
// ./src/services/Contact.js